"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

define(['choices'], function (Choices) {
  'use strict';

  return function (config, select) {
    var defaultOptions = _defineProperty({
      placeholder: false,
      searchEnabled: false,
      itemSelectText: '',
      position: 'bottom',
      sortFilter: function sortFilter(a, b) {
        return a.label.localeCompare(b.label);
      },
      classNames: {
        containerInner: 'select__field',
        list: 'select__field-list',
        input: 'select__field-input',
        item: 'select__field-item',
        listSingle: 'select__field-list--single'
      }
    }, "itemSelectText", '');

    if (config.type === 'number') {
      defaultOptions.sortFilter = function (a, b) {
        return a - b;
      };
    }

    config.options = Object.assign(defaultOptions, config.options);
    new Choices(select, config.options);
  };
});
//# sourceMappingURL=select.babel.js.map
